export default "__VITE_ASSET__DsvDm_7Z__"